import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px 20px;
  padding: 18px 20px;
  background-color: ${({ theme }) => theme.backgrounds.workspaceItem};
  border: 1px solid ${({ theme }) => theme.borders.workspaceItem};
  border-radius: 4px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const Label = styled.label`
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 11px;
  border: 1px solid ${({ theme }) => theme.borders.workspaceItem};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.textfield.background};
  color: ${({ theme }) => theme.textfield.text};
  font-size: 12.5px;

  &:focus {
    border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    outline: none;
  }
`;

export const Hint = styled.span`
  font-size: 11.5px;
  line-height: 1.45;
  color: ${({ theme }) => theme.text.emptyState};
`;
